import { useAction } from 'next-safe-action/hooks'

import { requestTossPaymentConfirm } from '@/entities/payment'
import { useServerErrorHandler } from '@/shared/config'

type RequestTossPaymentConfirmActionProps = {
  onSuccess: () => void
  onError: () => void
}

export const useRequestTossPaymentConfirm = ({
  onSuccess,
  onError,
}: RequestTossPaymentConfirmActionProps) => {
  const { handleServerError } = useServerErrorHandler()

  const action = useAction(requestTossPaymentConfirm, {
    onSuccess,
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError({
          ...error.serverError,
          onConfirm: onError,
        })
      }
    },
  })

  return action
}
